<template>
  <b-modal
    id="update-case-list"
    :title="$translate('Update case list')"
    hide-footer
    centered
    content-class="rounded-8"
    @hide="onClose"
    @show="getAllCaseList"
  >
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12">
        <Select
          v-model="selectedCaseListId"
          :options="allCaseList"
          form-group-id="selectedCaseList"
          :placeholder="'Chose case list' | i18n"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-lg-12 col-sm-12 col-xs-12 d-flex justify-content-between">
        <b-button variant="outline-secondary" size="lg" class="btn-delete-device mr-3 px-55" @click="onClose">
          {{ 'cancel' | i18n }}
        </b-button>
        <b-button variant="outline-primary" size="lg" class="px-55" :disabled="!selectedCaseListId" @click="onSubmit">
          {{ 'update' | i18n }}
        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import Select from '../../common/select';
import api from '../../../api';
import { NotificationMixin } from '../../../../mixins';

export default {
  name: 'UpdateCaseListModal',
  components: { Select },
  mixins: [NotificationMixin],
  props: {
    idList: {
      type: Array,
      default: () => [],
    },
  },
  data: function () {
    return {
      selectedCaseListId: '',
      allCaseList: [],
      allCaseListData: [],
    };
  },
  methods: {
    async getAllCaseList() {
      const allCaseList = await api.caseLists.get({});
      this.allCaseList = allCaseList.map(({ id, name }) => ({ value: id, text: name }));
      this.allCaseListData = allCaseList;
    },
    onClose() {
      this.onClear();
      this.$root.$emit('bv::hide::modal', 'update-case-list');
    },
    onClear() {
      this.selectedCaseListId = '';
      this.allCaseList = [];
      this.allCaseListData = [];
    },
    async onSubmit() {
      try {
        const selectedCaseList = this.allCaseListData.find(({ id }) => id === this.selectedCaseListId);
        const data = {
          name: selectedCaseList.name,
          idList: [...new Set([...selectedCaseList.casesList.map(({ id }) => id), ...this.idList.map(({ id }) => id)])],
        };
        await api.caseLists.update(this.selectedCaseListId, data);
        this.onClose();
        this.showNotification({ type: 'success', message: this.$translate('Case list was successfully updated!') });
      } catch (error) {
        this.showNotification({ type: 'error', message: error.message });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-header {
  border: none;
  padding-bottom: 0px !important;
}
.px-55 {
  padding-left: 55px;
  padding-right: 55px;
}
::v-deep .rounded-8 {
  border-radius: 8px;
}
::v-deep .btn-lg {
  font-size: 16px;
  line-height: 24px;
}
</style>
